import React, { useEffect } from 'react';
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import logo from "../assets/images/hisalogo.png";
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const Footer = () => {

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });

  }, []);

  return (
    <>

      <footer className="footer footer-one ">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <div className="footer-widget footer-about">
                  <div className="footer-logo mb-0">
                    <img src={logo} alt="logo" />
                  </div>
                  <div className="footer-about-content">
                    <p>
                      Specialist in Insurance, investments,money markets, retirement and financial advisory.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-4">
                <div className="footer-widget footer-menu">
                  <h2 className="footer-title">Our Clients</h2>
                  <ul>
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/profile" target="_blank" >My Profile</Link>
                    </li>
                    <li>
                      <Link to="https://hisaafricainsurance.com/" target="_blank">Hisa Website</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-4">
                <div className="footer-widget footer-menu">
                  <h2 className="footer-title">Hisa Africa</h2>
                  <ul>
                    <li>
                      <Link to="/appointments" target="_blank">Login</Link>
                    </li>
                    <li>
                      <Link to="/about-us" target="_blank">About Me</Link>
                    </li>
                    <li>
                      <Link to="/dashboard" target="_blank">Dashboard</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-5">
                <div className="footer-widget footer-contact">
                  <h2 className="footer-title">Contact Us</h2>
                  <div className="footer-contact-info">
                    <div className="footer-address">
                      <p>
                        <i>
                          <FeatherIcon icon="phone-call" style={{ width: "16px", height: "16px" }} />
                        </i> 0722310584
                      </p>
                    </div>
                    <div className="footer-address">
                      <p>
                        <i>
                          <FeatherIcon icon="map-pin" style={{ width: "16px", height: "16px" }} />
                        </i> Nairobi, Kenya
                      </p>
                    </div>
                    <div className="footer-address mb-0">
                      <p>
                        <i>
                          <FeatherIcon icon="mail" style={{ width: "16px", height: "16px" }} />
                        </i> alfred.mathu@hisaafricainsurance.com
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-7">
                <div className="footer-widget">
                  <h2 className="footer-title">Request Quote</h2>
                  <div className="quote-section mb-2">
                    <a
                      href="https://quote.hisaafricainsurance.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn quote-btn w-100"
                    >
                      Get A Quote
                    </a>
                  </div>
                  <div className="social-icon mb-0">
                    <ul className="d-flex justify-content-center">
                      <li className="mx-2">
                        <a
                          href="https://www.facebook.com/people/Alfred-Mathu/100015110167723/?mibextid=wwXIfr&rdid=ODuo0NkvxmuS1nkV&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1ALADxy8xw%2F%3Fmibextid%3DwwXIfr"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook" />
                        </a>
                      </li>
                      <li className="mx-2">
                        <a
                          href="https://www.instagram.com/hisaafrica/?igsh=MTF2NHFtNzJ0eWc5dg%3D%3D#/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                      <li className="mx-2">
                        <a
                          href="https://x.com/mathualfred?s=21/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 1200 1227" style={{ display: 'inline-block' }}>
                            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
                          </svg>
                        </a>
                      </li>
                      <li className="mx-2">
                        <a
                          href="https://www.linkedin.com/in/alfred-mathu-844b32119"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-3 col-md-7">
                <div className="footer-widget">
                  <h2 className="footer-title">Request for a proposal</h2>
                  <div className="subscribe-form mb-2">
                    <form action="https://www.linkedin.com/in/alfred-mathu-844b32119" target="_blank">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                      />
                      <button type="submit" className="btn">
                        Submit
                      </button>
                    </form>
                  </div>
                  <div className="social-icon">
                    <ul>
                      <li>
                        <Link to="https://hisaafricainsurance.com/" target="_blank">
                          <i className="fab fa-facebook" />{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="https://hisaafricainsurance.com/" target="_blank">
                          <i className="fab fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://hisaafricainsurance.com/" target="_blank">
                          <i className="fab fa-twitter" />{" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.linkedin.com/in/alfred-mathu-844b32119" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            {/* Copyright */}
            <div className="copyright ">
              <div className="row">
                <div className="col-md-6 col-lg-6">
                  <div className="copyright-text">
                    <p className="mb-0">
                      {" "}
                      Copyright © 2025{" "}
                      <Link
                        to="https://www.linkedin.com/in/wawerukungu"
                        target="_blank"
                      >
                        Ben Kung'u.
                      </Link>{" "}
                      All Rights Reserved
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-6">
                  {/* Copyright Menu */}
                  <div className="copyright-menu">
                    <ul className="policy-menu">
                      <li>
                        <Link to="/">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions">Terms and Conditions</Link>
                      </li>
                    </ul>
                  </div>
                  {/* /Copyright Menu */}
                </div>
              </div>
            </div>
            {/* /Copyright */}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;